import { classNames } from "../../utils/Helper";

export enum LeaguePlayerStatus {
  REMAINING,
  QUALIFIED,
  ON_QUALIFICATION,
  RELEGATION,
}

interface RankStatusProps {
  rank: number,
  status: LeaguePlayerStatus
  dark?: boolean
}

const RankStatus: React.FC<RankStatusProps> = ({rank, status, dark=false}) => {

  const borderColor = dark ? "border-black" : "border-white";

  const defaultCSS = "border-2 " + borderColor;
  const qualifiedCSS = "border-2 bg-victory-green " + borderColor;
  const onQualificationCSS = "border-2 border-dashed border-victory-green";
  const relegationCSS = "border-2 bg-red-500 " + borderColor;

  const reverseTextColor = dark || (!dark && status==1) || (!dark && status==3);

  let statusCss;

  switch (status) {
    case LeaguePlayerStatus.REMAINING:
      statusCss = defaultCSS
      break;
    case LeaguePlayerStatus.QUALIFIED:
      statusCss = qualifiedCSS
      break;
    case LeaguePlayerStatus.ON_QUALIFICATION:
      statusCss = onQualificationCSS
      break;
    case LeaguePlayerStatus.RELEGATION:
      statusCss = relegationCSS
      break;
    default:
      statusCss = defaultCSS
      break;
  }

  return (

    <div className={classNames("w-8 h-8 p-4 rounded-[288px] flex-col justify-center items-center gap-4 inline-flex", statusCss)}>

      <div className={classNames("text-sm font-bold font-['Satoshi']", reverseTextColor ? 'text-white' : 'text-black')}>
        {rank ? rank : "="}
      </div>

    </div>

   );
}

export default RankStatus;